import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorSocket,
  fetchProcessorSocketrAttributes,
  fetchProcessorSocketById,
  updateProcessorSocket,
  updateStatusInProcessorSocket,
} from "./thunk";

interface CategoryState {
  processor_socket_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_socket_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "processor_socket",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorSocketrAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSocketrAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_socket_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorSocketrAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Socket Type";
      })
      .addCase(fetchProcessorSocketById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorSocketById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorSocketById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_socket_list = state.processor_socket_list.map((processor_socket) =>
          processor_socket.id === action.payload.id ? action.payload : processor_socket
        );
      })
      .addCase(addProcessorSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_socket_list = state.processor_socket_list.map((processor_socket) =>
          processor_socket.id === action.payload.id ? action.payload : processor_socket
        );
      })
      .addCase(updateProcessorSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorSocket.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorSocket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
